import { LuCalendar, LuCheck, LuX } from 'react-icons/lu'

import { DatePicker } from '@/lib/core/components/DatePicker'

import { OpeningFilterPopout } from '../ExecutionBoardFilters/ExecutionBoardFilters'
import styles from '../ExecutionBoardFilters/ExecutionBoardFilters.module.css'
import { DATE_RANGE_OPTIONS } from './DateRangeFilterPopout.utils'
import { useDateRangeFilter } from './useDateRangeFilter'

export const DateRangeFilterPopout = ({
  setFilteringDateRange,
  currentDateRange,
  openingFilterPopout,
  onOpenFilterPopout,
}: {
  setFilteringDateRange: (dateRange: { start: Date; end: Date } | null) => void
  currentDateRange?: { start?: Date; end?: Date }
  openingFilterPopout: OpeningFilterPopout | null
  onOpenFilterPopout: (popout: OpeningFilterPopout) => void
}) => {
  const {
    selectedDateRange,
    selectedDateRangeMode,
    popoverPosition,
    filterButtonRef,
    dialogRef,
    showPopover,
    handleClose,
    handleSelectDateRange,
    handleClearAll,
    handleApply,
    onChangeCustomDateRange,
  } = useDateRangeFilter({
    setFilteringDateRange,
    currentDateRange,
    openingFilterPopout,
    onOpenFilterPopout,
  })

  const { bottom, right } = popoverPosition

  return (
    <div>
      <div
        ref={filterButtonRef}
        className={styles.dateRangeButton}
        data-testid="execution-board-button"
        onClick={showPopover}
      >
        <LuCalendar size="16" />
        {selectedDateRangeMode ? (
          <>{DATE_RANGE_OPTIONS.find((option) => option.value === selectedDateRangeMode)?.label}</>
        ) : (
          <>Date Range</>
        )}
      </div>

      <dialog
        ref={dialogRef}
        className={styles.dateRangePopupContainer}
        style={{ top: bottom + 10, left: right - 80 }}
        popover="manual"
      >
        <div className={styles.popoutHeader}>
          <div className={styles.headerActions}>
            <button
              className={styles.actionButton}
              data-testid="date-range-filter-close"
              onClick={() => handleClose(true)}
            >
              <LuX size={16} />
            </button>
          </div>
        </div>

        <div className={styles.radioWrapper}>
          {DATE_RANGE_OPTIONS.map((option) => (
            <label key={`option-date-range-${option.value}`} className={styles.basicRadio}>
              <input
                type="radio"
                value={option.value}
                onChange={() => handleSelectDateRange(option.value)}
                checked={option.value === selectedDateRangeMode}
              />
              {option.label}
              {option.value === selectedDateRangeMode && (
                <LuCheck size="24" className={styles.check} />
              )}
            </label>
          ))}
          {selectedDateRangeMode === 'custom' && (
            <DatePicker
              mode={'range'}
              initialDate={{
                from: selectedDateRange?.start?.toISOString(),
                to: selectedDateRange?.end?.toISOString(),
              }}
              onChange={onChangeCustomDateRange}
              postion="top"
              testId="custom-date-range-picker"
            />
          )}
        </div>
        <div className={styles.footerActions}>
          <button className={styles.clearAllButton} data-testid="date-range-filter-clear" onClick={handleClearAll}>
            Clear all
          </button>
          <button className={styles.applyButton} data-testid="date-range-filter-apply" onClick={handleApply}>
            Apply
          </button>
        </div>
      </dialog>
    </div>
  )
}
